import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { jobConverter } from "../models/jobModel";
import { saveData } from "./jobSlice";

const getJobs = () => {
  return (dispatch) => {
    const unsubscribe = onSnapshot(
      collection(db, "cms/website/jobs").withConverter(jobConverter),
      (querySnapshot) => {
        const resources = [];
        querySnapshot.forEach((doc) => {
          resources.push({ ...doc.data(), id: doc.id });
        });
        dispatch(saveData(resources));
      }
    );
  };
};

export { getJobs };
